import { Notify } from 'quasar'
Notify.setDefaults({
  position: 'top',
  classes: 'toaster',
  //   closeBtn: '✕',
  progress: true,
  progressClass: 'progress-border',
  color: 'white',
  timeout: 5000
})
const MyToaster = {
  setDefaults() {},
  success(message: string) {
    Notify.create({
      textColor: 'green-4',
      icon: 'icon-check-circle',
      message
    })
  },
  warning(message: string, html: boolean = false) {
    Notify.create({
      textColor: 'orange-6',
      icon: 'icon-alert-triangle',
      message,
      html
    })
  },
  error(message: string) {
    Notify.create({
      textColor: 'red-5',
      icon: 'icon-x-circle',
      message
    })
  },
  info(message: string) {
    Notify.create({
      textColor: 'black',
      icon: 'icon-alert-circle',
      message
    })
  }
}

export default MyToaster
